/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional workflow rules.
 */
export enum StatusBasedConditionType {
    STATUS_IS = 'StatusIs',
    STATUS_IS_NOT = 'StatusIsNot',
    STATUS_IS_BEFORE = 'StatusIsBefore',
    STATUS_IS_AFTER = 'StatusIsAfter',
}
